// Validační utility pro formuláře (kontakt + lead z kalkulačky).
// Cíl: jednoduché regex kontroly, žádný external lib, sdílené chybové hlášky.

// E-mail: praktický minimalistický regex (přesnější než nic, méně otravný než RFC 5322)
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Telefon: povolíme +, číslice, mezeru, závorky, pomlčku.
// Po odstranění oddělovačů musí zůstat 9–15 číslic (E.164 max 15).
const PHONE_ALLOWED_RE = /[^\d+\s()-]/g;
const PHONE_DIGITS_RE = /\d/g;

export function isValidEmail(s) {
  if (typeof s !== "string") return false;
  const v = s.trim();
  return v.length > 0 && v.length <= 254 && EMAIL_RE.test(v);
}

/** Filtruje znaky během psaní — povoluje `+ číslice mezera ( ) -`. */
export function sanitizePhone(s) {
  if (typeof s !== "string") return "";
  return s.replace(PHONE_ALLOWED_RE, "");
}

/** Volitelné pole — prázdná hodnota = ok; vyplněné musí dávat smysl. */
export function isValidPhone(s) {
  if (s == null) return true;
  const v = String(s).trim();
  if (v === "") return true;
  const digits = (v.match(PHONE_DIGITS_RE) || []).length;
  return digits >= 9 && digits <= 15;
}

/**
 * Vrací mapu { fieldName: errorMessage } pro kontaktní formulář.
 * Pole není v mapě = bez chyby.
 */
export function validateContact(d) {
  const e = {};
  const name = (d.name || "").trim();
  const email = (d.email || "").trim();
  const message = (d.message || "").trim();
  const phone = (d.phone || "").trim();

  if (!name) e.name = "Vyplňte prosím jméno.";
  else if (name.length < 2) e.name = "Jméno je příliš krátké.";

  if (!email) e.email = "Vyplňte prosím e-mail.";
  else if (!isValidEmail(email)) e.email = "Zadejte e-mail ve tvaru jmeno@domena.cz.";

  if (phone && !isValidPhone(phone)) e.phone = "Zadejte platné telefonní číslo.";

  if (!message) e.message = "Vyplňte prosím zprávu.";
  else if (message.length < 5) e.message = "Zpráva je příliš krátká.";
  else if (message.length > 4000) e.message = "Zpráva je příliš dlouhá.";

  if (!d.gdpr_consent) e.gdpr_consent = "Bez souhlasu nemůžeme zprávu odeslat.";

  return e;
}

/** Lead formulář v kalkulačce — bez `message`, ale s volitelnou `note`. */
export function validateLead(d) {
  const e = {};
  const name = (d.name || "").trim();
  const email = (d.email || "").trim();
  const phone = (d.phone || "").trim();

  if (!name) e.name = "Vyplňte prosím jméno.";
  else if (name.length < 2) e.name = "Jméno je příliš krátké.";

  if (!email) e.email = "Vyplňte prosím e-mail.";
  else if (!isValidEmail(email)) e.email = "Zadejte e-mail ve tvaru jmeno@domena.cz.";

  if (phone && !isValidPhone(phone)) e.phone = "Zadejte platné telefonní číslo.";

  if (!d.gdpr_consent) e.gdpr_consent = "Bez souhlasu nemůžeme poptávku odeslat.";

  return e;
}
